import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useDemands } from '@contexts/DemandsContext';

/**
 * Busca por texto no board de Demandas (número/descrição) — mesma funcionalidade e critério do
 * app mobile (Searchbar em demands.tsx). Fica na Toolbar, ao lado do botão de filtros, só na
 * página de Demandas (achado real 26/08/2026: web não tinha essa busca, só filtros estruturados).
 * `searchText` mora em DemandsContext (não persiste em localStorage, igual ao mobile) — quem
 * aplica de fato o filtro é useDemandFilters.ts, junto com os demais.
 */
interface DemandsSearchFieldProps {
  /** Ocupa a largura toda do container — usado no drawer de filtros mobile-web (vs. largura fixa
   * na Toolbar desktop). */
  fullWidth?: boolean;
}

export const DemandsSearchField: React.FC<DemandsSearchFieldProps> = ({ fullWidth = false }) => {
  const { searchText, setSearchText } = useDemands();

  return (
    <TextField
      size="small"
      fullWidth={fullWidth}
      placeholder="Buscar demandas"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search fontSize="small" sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        width: fullWidth ? '100%' : 200,
        backgroundColor: 'background.paper',
        borderRadius: 1,
        '& .MuiOutlinedInput-root': { height: 40 },
      }}
    />
  );
};

export default DemandsSearchField;
